import React, { useState, useEffect } from 'react'
import { useAuthStore } from '../../stores/authStore'
import { organizationService, Organization } from '../../services/organizationService'
import OrganizationAccounts from '../support/OrganizationAccounts'

const ManageAccountsSettings: React.FC = () => {
  const { user } = useAuthStore()
  const [organization, setOrganization] = useState<Organization | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchOrg = async () => {
      if (!user?.organizationId) return
      try {
        const response = await organizationService.getOrganization(user.organizationId)
        if (response.success && response.data) {
          setOrganization(response.data)
        }
      } finally {
        setLoading(false)
      }
    }
    fetchOrg()
  }, [user?.organizationId])

  if (loading) {
    return (
      <div className='flex items-center justify-center py-12'>
        <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500' />
      </div>
    )
  }

  if (!organization) {
    return (
      <div className='text-center py-12'>
        <p className='text-sm text-gray-500'>Unable to load organization data.</p>
      </div>
    )
  }

  return <OrganizationAccounts organization={organization} />
}

export default ManageAccountsSettings
